var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.192 4.86956L15.227 2.89856C13.81 1.47756 13.255 0.713557 12.489 0.983557C11.532 1.32056 11.847 3.44656 11.847 4.16356C10.361 4.16356 8.815 4.03256 7.35 4.30756C2.513 5.21556 1 9.14356 1 13.4286C2.37 12.4586 3.737 11.4256 5.382 10.9766C7.436 10.4146 9.73 10.6826 11.847 10.6826C11.847 11.4006 11.533 13.5266 12.489 13.8636C13.357 14.1696 13.81 13.3696 15.227 11.9486L17.192 9.97656C18.397 8.76656 19 8.16156 19 7.42356C19 6.68356 18.397 6.07956 17.192 4.86956Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.55e232e35e376dd12964e2cda294099d.svg";
export { ForwardRef as ReactComponent };